import React, { useContext } from 'react'
import { createFormattedDateFromStr } from './helpers/dateFunctions'
import CellRow from './CellRow'
import { DataContext, StyleContext } from './GanttChart'
import { BackTop } from 'antd'

const ResourceRow = ({ color, r }) => {
  const { taskDurations, curYear, curMonth, numDays, tasks } =
    useContext(DataContext)
  const { columnValue, lockHeight } = useContext(StyleContext)
  const ganttTimePeriod = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: `minmax(${columnValue}px, 1fr)`,
    textAlign: 'center',
    outline: 'none',
    height: `${lockHeight ? 29 : columnValue / 5 + 10}px`,
    backgroundColor: '#F4F6FA'
  }

  let weekRow = []
  let dates = []
  for (let i = 1; i <= numDays; i++) {
    const formattedDate = createFormattedDateFromStr(curYear, curMonth, i)
    tasks.map((el) => {
      let obj = el.cranes.find((o) => o.id === r.id)
      if (obj) {
        const start = Date.parse(el.start.substr(0, 10))
        const end = Date.parse(el.end.substr(0, 10))
        const d = Date.parse(formattedDate)
        if (d >= start && d <= end) {
          dates.push(i)
        }
      }
    })
  }

  for (let j = 1; j <= numDays; j++) {
    weekRow.push(
      <div key={j} style={ganttTimePeriodCell}>
        {dates.includes(j) ? <CellRow color='' /> : <CellRow color={color} />}
      </div>
    )
  }

  return <div style={ganttTimePeriod}>{weekRow}</div>
}

export default ResourceRow

// styling
const ganttTimePeriodCell = {
  position: 'relative',
  outline: '2px solid #cecece',
  marginTop: '3.5px',
  backgroundColor: '#fff',
  padding: '4px'
}
